import * as React from 'react';
import { InputOTP } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

const states = ['default', 'disabled'] as const;
const lengths = [4, 6, 8] as const;

type ShowcaseState = (typeof states)[number];
type OtpLength = (typeof lengths)[number];

export function InputOTPShowcase() {
  const [state, setState] = React.useState<ShowcaseState>('default');
  const [maxLength, setMaxLength] = React.useState<OtpLength>(6);
  const [value, setValue] = React.useState('');

  return (
    <div className="space-y-4">
      <StateToggle options={states} value={state} onChange={setState} label="State" />
      <StateToggle options={lengths} value={maxLength} onChange={setMaxLength} label="Length" />
      <InputOTP
        value={value}
        onChange={setValue}
        maxLength={maxLength}
        disabled={state === 'disabled'}
        ariaLabel="Verification code"
      />
      <p className="text-xs text-muted-foreground">Value: {value || 'empty'}</p>
    </div>
  );
}
